import "./Home.module.css";
import Navigation from "@/reusable_sections/Header";
import Diagnostic from "./sections/Diagnostic";
import ProcessGap from "./sections/ProcessGap";
import Insights from "./sections/Insights";
import Pilot from "./sections/Pilot";
import Faq from "./sections/Faq";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Navigation />
      <Diagnostic />
      <ProcessGap />
      <Insights />
      <Faq />
      <Pilot />
      <Footer />
    </div>;
}